import { render, staticRenderFns } from "./PasswordSet.vue?vue&type=template&id=649322df&"
import script from "./PasswordSet.vue?vue&type=script&lang=js&"
export * from "./PasswordSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports